<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>{{ $t('DEBTIA_CASE_GROUP') }}</label>
              <v-select
                v-model="caseGroupValue"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                class="casegroups per-page-selector d-inline-block mx-50"
                :options="[{label: 'All', value: ''}, ...caseGroups]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="casegroups"
              />
            </b-col><b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>{{ $t('DEBTIA_STATUS') }}</label>
              <v-select
                v-model="caseState"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                class="casegroups per-page-selector d-inline-block mx-50"
                :options="[{label: 'All', value: ''}, {label: $t('DEBTIA_PENDING'), value: 0}, {label: $t('DEBTIA_ACCEPTED'), value: 1}, {label: $t('DEBTIA_DECLINED'), value: 2}, {label: $t('DEBTIA_TERMINATED') , value: 3}, {label: $t('DEBTIA_PAUSED') , value: 4}]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="caseState"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />

                <b-button
                  v-if="$ability.can(constants.action.permissionDebtCaseAdd, constants.resource.debtCase) && !isSuperAdmin"
                  id="add-case-btn"
                  v-b-modal.modal-role-cases
                  variant="primary"
                  @click="addCase(addCaseInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_CASE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>{{ $t('DEBTIA_PROCESSES') }}</label>
              <v-select
                v-model="processId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                class="casegroups per-page-selector d-inline-block mx-50"
                :options="[{label: 'All', value: ''},{ label: $t('DEBTIA_DEBT_CASE_ACTIVE_PROCESS') , value: 0 }, ...processes]"
                :reduce="val => val.value"
                :clearable="false"
                input-id="processId"
              />
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative resource-listing"
          responsive
          selectable
          :fields="tableFields"
          :select-mode="selectMode"
          :items="casesData"
          hover
          @row-selected="onRowSelected"
        >
          <template #cell(id)="data">
            <b-link
              target="_blank"
              :to="{ name: 'case-details', params: { id: data.item.id } }"
            >
              <div>
                {{ (data.item.g_prefix) ? data.item.g_prefix+data.item.id : data.item.id }}
              </div>
            </b-link>
          </template>
          <template #cell(base_type)="data">
            <b-link
              target="_blank"
              :to="{ name: 'case-details', params: { id: data.item.id } }"
            >
              <div>{{ (data.item.base_type) ? data.item.base_type.name : '' }}</div>
            </b-link>
          </template>
          <template #cell(client_name)="data">
            <b-media vertical-align="center">
              <b-link
                class="font-weight-bold d-block text-nowrap client-name"
                target="_blank"
                :to="{ name: 'case-details', params: { id: data.item.id } }"
              >
                <div>
                  <div>{{ data.item.client.name }}</div>
                  <small class="text-muted">@{{ data.item.client.username }}</small>
                </div>
              </b-link>
            </b-media>
          </template>
          <template #cell(case_group)="data">
            <b-link
              target="_blank"
              :to="{ name: 'case-details', params: { id: data.item.id } }"
            >
              <div>{{ (data.item.debt_case_group) ? data.item.debt_case_group.title : 'N/A' }}</div>
            </b-link>
          </template>
          <template #cell(status)="data">
            <b-link
              target="_blank"
              :to="{ name: 'case-details', params: { id: data.item.id } }"
            >
              <b-badge
                v-if="data.item.status === 0 || data.item.status === null"
                pill
                variant="warning"
              >
                {{ $t('DEBTIA_PENDING') }}
              </b-badge>
              <b-badge
                v-if="data.item.status === 1"
                pill
                variant="success"
              >
                {{ $t('DEBTIA_ACCEPTED') }}
              </b-badge>
              <b-badge
                v-if="data.item.status === 2"
                pill
                variant="danger"
              >
                {{ $t('DEBTIA_DECLINED') }}
              </b-badge>
              <b-badge
                v-if="data.item.status === 3"
                pill
                variant="danger"
              >
                {{ $t('DEBTIA_TERMINATED') }}
              </b-badge>
              <b-badge
                v-if="data.item.status === 4"
                pill
                variant="warning"
              >
                {{ $t('DEBTIA_PAUSED') }}
              </b-badge>
            </b-link>
          </template>
          <!-- <template #cell(action)="data">
            <b-link
              v-if="$ability.can(constants.action.permissionDebtCaseView, constants.resource.debtCase)"
              :to="{ name: 'case-details', params: { id: data.item.id } }"
              class="margin-right: 15px; font-weight-bold d-block text-nowrap"
            >
              <feather-icon
                icon="EyeIcon"
              />
            </b-link>
          </template> -->
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <!-- <cases-modal
          ref="create-case-modal"
          :modal-loads="modalLoader"
          :reload-method="getCases"
          :case-groups="caseGroups"
        /> -->
        <!-- <case-details
          :case-id="caseId"
          :modal-loads="modalLoader"
          :reload-method="getCases"
          :show="!modalLoader"
          :case-busy="busy"
        /> -->
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BMedia, BLink, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
// import CasesModal from './CasesModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    BMedia,
    BLink,
    vSelect,
    BFormInput,
    BButton,
    BBadge,
    BPagination,
    // CasesModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      casesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addCaseInput: {
        id: 0,
        name: '',
        description: '',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      caseId: 0,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      wordFile: false,
      finalStep: false,
      showVariables: false,
      busy: false,
      clicked: false,
      searchRun: false,
      selectMode: 'single',
      selected: [],
      caseGroups: [],
      caseGroupValue: '',
      processes: [],
      processId: '',
      caseState: '',
    }
  },
  computed: {
    tableFields() {
      let fields = []
      if (this.user_type === 'super-admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'base_type', sortable: true, label: i18n.t('DEBTIA_BASE_TYPE') },
          { key: 'client_name', sortable: true, label: i18n.t('DEBTIA_CLIENT_NAME') },
          { key: 'case_group', label: i18n.t('DEBTIA_CASE_GROUP') },
          { key: 'status', label: i18n.t('DEBTIA_STATUS') },
          // { key: 'companyname', sortable: true, label: i18n.t('DEBTIA_COMPANY_NAME') },
          // { key: 'active_module', label: i18n.t('DEBTIA_ACTIVE_MODULE') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'base_type', sortable: true, label: i18n.t('DEBTIA_BASE_TYPE') },
          { key: 'client_name', sortable: true, label: i18n.t('DEBTIA_CLIENT_NAME') },
          { key: 'case_group', label: i18n.t('DEBTIA_CASE_GROUP') },
          { key: 'status', label: i18n.t('DEBTIA_STATUS') },
          // { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getCases()
      },
    },
    currentPage: {
      handler() {
        this.getCases()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCases()
      },
    },
    caseGroupValue: {
      handler() {
        this.currentPage = 1
        this.getCases()
      },
    },
    processId: {
      handler() {
        this.getCases()
      },
    },
    caseState: {
      handler() {
        this.getCases()
      },
    },
  },
  created() {
    this.getCases()
    if (this.$route.meta.nav) setTimeout(() => { this.$root.$emit('bv::show::modal', 'modal-role-cases') }, 1000)
  },
  methods: {
    onRowSelected(item) {
      this.selected = item
      this.$router.push({ name: 'case-details', params: { id: item['0'].id } })
    },
    async getCases() {
      try {
        if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const cases = await axios.get(`${constants.baseUrl}/debt-cases?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&groupId=${this.caseGroupValue}&processId=${this.processId}&caseState=${this.caseState}&sortDesc=true`)
        if (cases.status) {
          this.loader = false
          // console.log('cases', cases)
          this.casesData = cases.data.data.data
          // console.log('casesData', this.casesData)
          this.totalPages = cases.data.data.total
          this.from = cases.data.data.from
          this.to = cases.data.data.to
          this.currentPage = cases.data.data.current_page
        }
      } catch (error) {
        console.log('error is ', error.response.data)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    caseDetails(id) {
      this.busy = true
      this.caseId = id
    },
    addCase(item) {
      this.modalLoader = true
      this.wordFile = !this.wordFile
      this.finalStep = !this.finalStep
      this.showVariables = !this.showVariables
      this.editData = item
      this.modalLoader = false
      this.clicked = !this.clicked
      this.$refs['create-case-modal'].getClients()
      this.$refs['create-case-modal'].getCaseGroups()
    },
    async deleteCase(id) {
      this.loader = true
      const cases = await axios.post(`${constants.baseUrl}/cases/delete`,
        { caseID: id })
      if (cases.status) {
        this.getCases()
      }
      this.loader = false
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionLetterTemplateEdit, this.constants.resource.letterTemplate) && this.$ability.cannot(this.constants.action.permissionLetterTemplateDelete, this.constants.resource.letterTemplate)) {
        if (this.user_type !== 'super-admin') {
          this.tableFields.splice(2, 1)
        } else {
          this.tableFields.splice(3, 1)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}

.casegroups .vs__dropdown-toggle{
  width: 200px;
}
</style>
